import React from 'react';
import { wrapTextWithTagFormatter } from './wrapTextWithTag';

/**
 * Wrap translation template in a bold tag.
 * @type {function} boldFormatter
 * @returns {node} Wrapped react node.
 */
export const boldFormatter = wrapTextWithTagFormatter(null, 'b');
